import { useMutation } from "@tanstack/react-query";

import getTbiApi from "@/api/api-v1";

export function useLogin() {
  return useMutation({
    mutationFn: async (email: string) => {
      await getTbiApi().SendLoginLinkApi.sendLoginLinkCreate({
        login: {
          email,
        },
      });
    },
  });
}
